export default __webpack_public_path__ + "static/media/standout-resumes.f844cb72.svg";